module.exports = __webpack_public_path__ + "static/media/goldenprize-mackerel-th.f592a076.png";